import { render } from "./TopBarPC.vue?vue&type=template&id=ad2ca252&scoped=true"
import script from "./TopBarPC.vue?vue&type=script&lang=js"
export * from "./TopBarPC.vue?vue&type=script&lang=js"

import "./TopBarPC.vue?vue&type=style&index=0&id=ad2ca252&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad2ca252"]])

export default __exports__